export default __webpack_public_path__ + "static/media/ShareholderMeetingLetter.88dbbd17.pdf";